'use client'

import { HeaderSection } from '@/components/shared/header-section'
import { useQuery } from '@apollo/client'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { PageContent } from '@/components/shared/page-content'
import { useLanguage } from '@/context/LanguageContext'
import useOpenDrawer from '@/hooks/useOpenDrawer'
import { GET_PAGE_TAGS } from './pageTagQueries'
import PageTagForm from './components/PageTagForm'
import { PageTag, getTagName } from './types'

export default function PageTags() {
  const { language: currentLanguage } = useLanguage()

  const { data, loading } = useQuery(GET_PAGE_TAGS, {
    fetchPolicy: 'cache-and-network',
  })

  const tags: PageTag[] = data?.findManyPageTag || []

  const openTagForm = useOpenDrawer(PageTagForm)

  return (
    <PageContent>
      <div className="flex justify-between items-center">
        <HeaderSection title="Page Tags" />
        <div className="flex items-center gap-2">
          <Button onClick={() => openTagForm({})}>Create New +</Button>
        </div>
      </div>

      <div className="rounded-md border">
        {/* Table header */}
        <div className="grid grid-cols-[1fr_1fr] gap-2 px-4 py-3 bg-muted/50 text-xs font-medium text-muted-foreground border-b">
          <div>Name</div>
          <div>Slug</div>
        </div>

        {/* Table body */}
        {loading && tags.length === 0 ? (
          <div className="p-4 space-y-3">
            {[1, 2, 3, 4, 5].map(i => (
              <Skeleton key={i} className="h-10 w-full" />
            ))}
          </div>
        ) : tags.length === 0 ? (
          <div className="p-8 text-center text-muted-foreground text-sm">
            No page tags yet. Create a tag to get started.
          </div>
        ) : (
          <div>
            {tags.map(tag => (
              <div
                key={`tag-${tag.id}`}
                className="grid grid-cols-[1fr_1fr] gap-2 px-4 py-2.5 border-b hover:bg-muted/30 cursor-pointer items-center"
                onClick={() => openTagForm({ id: tag.id })}
              >
                <span className="text-sm truncate">
                  {getTagName(tag, currentLanguage)}
                </span>
                <span className="text-sm text-muted-foreground truncate">
                  {tag.slug || '—'}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </PageContent>
  )
}
